import { useState } from "react";
import { ChevronRight, Heart, Flame, Sparkles, X, MapPin, LogOut } from "lucide-react";

const HERO =
  "https://customer-assets.emergentagent.com/job_854ade93-ee38-432f-af2e-3c6994248e8a/artifacts/if231j0o_Captura%20de%20tela%202026-05-18%20105008.png";

const GALLERY = [
  "https://customer-assets.emergentagent.com/job_854ade93-ee38-432f-af2e-3c6994248e8a/artifacts/095vsq4b_Captura%20de%20tela%202026-05-18%20105133.png",
  "https://customer-assets.emergentagent.com/job_854ade93-ee38-432f-af2e-3c6994248e8a/artifacts/0ebcz66a_Captura%20de%20tela%202026-05-18%20104802.png",
  "https://customer-assets.emergentagent.com/job_854ade93-ee38-432f-af2e-3c6994248e8a/artifacts/k367blaa_Captura%20de%20tela%202026-05-18%20105301.png",
  "https://customer-assets.emergentagent.com/job_854ade93-ee38-432f-af2e-3c6994248e8a/artifacts/2ttol064_Captura%20de%20tela%202026-05-18%20105633.png",
];

const API_BASE = process.env.REACT_APP_BACKEND_URL || "";
// External links are never present in the source bundle — backend resolves them
// behind a cloaked redirect that 404s for social bots.
const PRIVACY_URL = `${API_BASE}/api/r/l`;
const ONLYFANS_URL = `${API_BASE}/api/r/s`;
const FATALFANS_URL = `${API_BASE}/api/r/f`;

export default function LinksPage() {
  const [lightbox, setLightbox] = useState(null);

  const handleLogout = () => {
    sessionStorage.removeItem("foo_verified");
    window.location.reload();
  };

  return (
    <div className="links-wrap" data-testid="links-page">
      <div className="links-inner">
        {/* Hero */}
        <div className="hero-card" data-testid="hero-card">
          <img src={HERO} alt="Foo" className="hero-img" />
          <div className="hero-overlay">
            <div className="hero-badges">
              <span className="badge pink" data-testid="badge-online">
                <Sparkles
                  size={11}
                  style={{ display: "inline", marginRight: 4, marginBottom: -1 }}
                />
                online agora
              </span>
              <span className="badge" data-testid="badge-location">
                <MapPin
                  size={11}
                  style={{ display: "inline", marginRight: 4, marginBottom: -1 }}
                />
                Brasil 🇧🇷
              </span>
            </div>
            <h1 className="hero-name" data-testid="hero-name">
              Oi nenê <span className="heart">🌸</span>
            </h1>
            <p className="hero-bio" data-testid="hero-bio">
              sou a <b>Foo</b> 🍊 — escolhe por onde quer me ver:
            </p>
          </div>
        </div>

        {/* CTAs */}
        <div className="cta-stack">
          <a
            href={FATALFANS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="cta cta-privacy"
            data-testid="cta-fatalfans"
          >
            <span className="shimmer" />
            <span className="left">
              <span className="icon-bubble">
                <Flame size={18} strokeWidth={2.4} />
              </span>
              <span style={{ display: "flex", flexDirection: "column" }}>
                <span>Fatal • acesso completo</span>
                <span className="sub">o melhor de mim tá aqui 🔥</span>
              </span>
            </span>
            <ChevronRight className="arrow" size={22} />
          </a>

          <a
            href={PRIVACY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="cta cta-onlyfans"
            data-testid="cta-privacy"
          >
            <span className="left">
              <span
                className="icon-bubble"
                style={{ background: "rgba(255, 126, 177, 0.18)" }}
              >
                <Flame size={18} strokeWidth={2.4} />
              </span>
              <span style={{ display: "flex", flexDirection: "column" }}>
                <span>Laranjinha</span>
                <span className="sub">tô esperando você lá 🍊</span>
              </span>
            </span>
            <ChevronRight className="arrow" size={22} />
          </a>

          <a
            href={ONLYFANS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="cta cta-onlyfans"
            data-testid="cta-onlyfans"
          >
            <span className="left">
              <span
                className="icon-bubble"
                style={{ background: "rgba(255, 126, 177, 0.18)" }}
              >
                <Heart size={18} strokeWidth={2.4} />
              </span>
              <span style={{ display: "flex", flexDirection: "column" }}>
                <span>Meus segredinhos</span>
                <span className="sub">vem mais perto de mim 💕</span>
              </span>
            </span>
            <ChevronRight className="arrow" size={22} />
          </a>
        </div>

        {/* Gallery */}
        <div className="gallery-title foo-script" data-testid="gallery-title">
          <span>um pouquinho de mim</span>
          <span className="line" />
          <span style={{ fontSize: 22 }}>🌸</span>
        </div>

        <div className="gallery-grid" data-testid="gallery-grid">
          {GALLERY.map((src, i) => (
            <button
              key={i}
              className="gallery-item"
              onClick={() => setLightbox(src)}
              data-testid={`gallery-item-${i}`}
              aria-label={`Foto ${i + 1}`}
            >
              <img src={src} alt={`Foo ${i + 1}`} loading="lazy" />
              <span className="pin">
                <Heart size={14} strokeWidth={2.6} fill="#fff" />
              </span>
            </button>
          ))}
        </div>

        <p className="foot" data-testid="foot">
          feito com <span className="heart">♥</span> pra quem é
          fã da Foo
          <br />
          © {new Date().getFullYear()} Fooquinha • todos os direitos reservados
        </p>

        <button
          type="button"
          onClick={handleLogout}
          className="back-gate"
          data-testid="back-to-gate"
          aria-label="Voltar para a verificação"
        >
          <LogOut size={11} strokeWidth={2.4} />
          <span>sair</span>
        </button>
      </div>

      {lightbox && (
        <div
          className="lightbox"
          onClick={() => setLightbox(null)}
          data-testid="lightbox"
        >
          <button
            className="lightbox-close"
            onClick={() => setLightbox(null)}
            data-testid="lightbox-close"
            aria-label="Fechar"
          >
            <X size={20} />
          </button>
          <img src={lightbox} alt="Foo" />
        </div>
      )}
    </div>
  );
}
